/**
 * useVehicleDatabase Hook
 *
 * Encapsulates vehicle database fetch for the FleetBuilder section.
 */

import { useState, useEffect } from 'react';
import { useAuth } from '@vortx/shared-ui';
import * as evService from '@vortx/shared-ui/src/services/evProjectService';

export function useVehicleDatabase() {
    const { currentUser } = useAuth();

    const [vehicles, setVehicles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!currentUser) return;

        const load = async () => {
            try {
                setLoading(true);
                const data = await evService.getVehicleDatabase(currentUser);
                setVehicles(data.vehicles || []);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        load();
    }, [currentUser]);

    return { vehicles, loading, error };
}
